import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { Bar, Line, Scatter } from "react-chartjs-2";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import SegmentedDonutChart from "./segmentedDonutChart";
import SegmentedTrafficBar from "./segmentedTrafficBar";
import Card from "../components/card";
import BackHeader from "../components/backHeader";
import { useNavigate } from "react-router-dom";
import { BlackButton } from "../components/buttonContainer";
import Input from "../components/inputContainer";
import { LocationData } from "./locationdata";
// import { getCookie } from "../config/webStorage";
// import { Link } from "react-router-dom";
// import Storepopup from "../components/storepopup";
// import { RxCross2 } from "react-icons/rx";
// import { FaStore, FaCalendarAlt, FaGlobe, FaMapMarkerAlt, FaCity} from "react-icons/fa";

function AnalyticsReport() {
  const {
    userData,
    permissions,
    // storeData,
    // getstoresLoading,
    // setCloseProfile,
  } = useUser();
  // const token = getCookie("bb_token");
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  // const [isPopupOpen, setPopupOpen] = useState(false);
  // const [pdfPopupOpen, setPdfPopupOpen] = useState(false);
  // const [todayCount, setTodayCount] = useState("00");
  // const [totalpdf, SetTotalPdf] = useState("00");
  // const [selectedRange, setSelectedRange] = useState("today");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  // const [AnalyticsData, setAnalyticsData] = useState("");
  // const [loadingData, setLoadingData] = useState(false);
  const [selectedRange] = useState("today");
  const [startDate] = useState("");
  const [endDate] = useState("");

  // console.log("select range : ", selectedRange);
  // console.log("startDate : ", startDate);
  // console.log("endDate : ", endDate);

  const navigate = useNavigate();

  // const handleRangeChange = (e) => {
  //   setSelectedRange(e.target.value);
  //   // Clear custom dates if another range is selected
  //   if (e.target.value !== "custom") {
  //     setStartDate("");
  //     setEndDate("");
  //   }
  // };

  // const openPopup = () => {
  //   setPopupOpen(true);
  // };

  // const closePopup = () => {
  //   setPopupOpen(false);
  // };

  const trafficData = {
    title: "Website Traffic",
    subtitle: "Unique visitors",
    totalVisitors: 26751,
    segments: [
      { label: "Direct", value: 14750, color: "#1f77b4" },
      { label: "Organic", value: 8000, color: "#2ca02c" },
      { label: "Referral", value: 2500, color: "#ff7f0e" },
      { label: "Social", value: 1500, color: "#d62728" },
    ],
  };

  // useEffect(() => {
  //   FilterHandler();
  // }, []);

  const [analytics, setAnalytics] = useState();
  // const FilterHandler = () => {
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     period: selectedRange,
  //     startDate: startDate,
  //     endDate: endDate,
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/analytic/report/filter`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       if (response.data?.success === true) {
  //         setAnalytics(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   if (selectedRange !== "customDate") {
  //     FilterHandler();
  //   }
  // }, [selectedRange]);

  // const PieData = {
  //   labels: ["Active User", "Total Users"],
  //   datasets: [
  //     loadingData
  //       ? {
  //           label: "loading data",
  //           data: [
  //             45, 100,
  //             // dashboardData?,
  //           ],
  //           backgroundColor: ["rgb(255,225,225,1)", "rgb(225,225,225,0.3)"],
  //           hoverOffset: 2,
  //         }
  //       : {
  //           label: "user data",
  //           data: [
  //             AnalyticsData?.activeUserCount,
  //             AnalyticsData?.userCount,
  //             // dashboardData?,
  //           ],
  //           backgroundColor: ["rgb(255, 99, 132)", "rgb(54, 162, 235)"],
  //           hoverOffset: 2,
  //         },
  //   ],
  // };
  // const data = {
  //   labels: ["week 1", "week 2", "week 3", "week 4"],
  //   datasets: [
  //     {
  //       label: "First dataset",
  //       data:
  //         AnalyticsData && AnalyticsData?.weeklyData.map((item) => item.count),
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(75,192,192,0.2)",
  //       borderColor: "rgba(75,192,192,1)",
  //     },
  //   ],
  // };
  // const dummyGraph = {
  //   labels: ["week 1", "week 2", "week 3", "week 4"],

  //   datasets: [
  //     {
  //       label: "loading dataset",
  //       data: [33, 53, 85, 41],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(235, 235, 235,0.2)",
  //       borderColor: "rgba(235, 235, 235,1)",
  //     },
  //   ],
  // };

  // --------------FILTERD POPUP BY TYPE --------------------------

  useEffect(() => {
    const FilterHandler = () => {
      let data = JSON.stringify({
        vendorObjId: vendorObjId,
        period: selectedRange,
        startDate,
        endDate,
      });

      axios
        .post(`${apiurl}/admin/v1/analytic/report/filter`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.data?.success === true) {
            setAnalytics(response.data.data);
          }
        })
        .catch(console.log);
    };

    if (selectedRange !== "customDate") {
      FilterHandler();
    }
  }, [selectedRange, vendorObjId, startDate, endDate]);

  const [popUpType, setPopUpType] = useState("");
  const [isOpenFiler, setIsOpenFiler] = useState(false);
  // const [filterdStores, setFilterdStores] = useState("");
  const [filterdStores] = useState("");
  // const [chooseFilteredBy, setChooseFilteredBy] = useState("");

  const stateData = {
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CG: "Chhattisgarh",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu and Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TR: "Tripura",
    UK: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West Bengal",
    AN: "Andaman and Nicobar Islands",
    CH: "Chandigarh",
    DH: "Dadra and Nagar Haveli",
    DL: "Delhi",
    LD: "Lakshadweep",
    PY: "Puducherry",
  };

  const [stateFilter, setStateFilter] = useState("");

  console.log("stateFilter", stateFilter);

  // useEffect(() => {
  //   if (stateFilter) {
  //     StateFilterHandler();
  //   }
  // }, [stateFilter]);

  // const StateFilterHandler = () => {
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     type: popUpType,
  //     province_code: "UP",
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/analytic/report/state/action`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       if (response.data.success === true) {
  //         console.log(JSON.stringify("filterdStores State", response.data));
  //         setFilterdStores(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const [showFilterPopUp, setShowFilterPopUp] = useState(true);

  // const filterHandler = () => {};

  const Select = ({
    children,
    className,
    label,
    icon,
    ContainerClassName,
    ...props
  }) => (
    <div className={`${ContainerClassName}`}>
      {label && <Input.Normal label={label} isInput={false} />}
      <div className=" cursor-pointer flex items-center w-full border py-2 px-2 rounded-md gap-1">
        {icon && <span className="text-gray-500">{icon}</span>}
        <select
          className={`${className}  pr-4 outline-none block w-full sm:text-sm rounded-md `}
          {...props}
        >
          {children}
        </select>
      </div>
    </div>
  );

  // const [timeType, setTimeType] = useState("");

  const { countries, states, cities } = LocationData;

  const [advanceFilterData, setAdvanceFilterData] = useState({
    catalogStatus: "catalog_generated",
    timeType: "",
    selectedCountry: "",
    selectedState: "",
    selectedCity: "",
    startDate: "",
    endDate: "",
    week: "",
    month: "",
    quarter: "",
    year: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdvanceFilterData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const advanceFilterHandler = () => {
    setShowFilterPopUp(false);
  };

  // const ColorCardCode = [
  //   "#000000", // Black
  //   "#FF5733", // Vibrant Orange
  //   "#33FF57", // Bright Green
  //   "#3357FF", // Strong Blue
  //   "#F1C40F", // Golden Yellow
  //   "#9B59B6", // Soft Purple
  //   "#E74C3C", // Bold Red
  //   "#1ABC9C", // Teal Green
  // ];

  // =======================POPUP ANALYTICS =================

  const dummyGraph = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],

    datasets: [
      {
        label: "Dataset 1",
        data: [600, 300, 900, 1400],
        fill: true,
        tension: 0.2,
        backgroundColor: "rgba(75,192,192,0.2)", // Teal
        borderColor: "rgba(75,192,192,1)",
      },
      {
        label: "Dataset 2",
        data: [400, 500, 700, 1000],
        fill: true,
        tension: 0.2,
        backgroundColor: "rgba(255,99,132,0.2)", // Red
        borderColor: "rgba(255,99,132,1)",
      },
      {
        label: "Dataset 3",
        data: [200, 400, 600, 800],
        fill: true,
        tension: 0.2,
        backgroundColor: "rgba(54,162,235,0.2)", // Blue
        borderColor: "rgba(54,162,235,1)",
      },
      {
        label: "Dataset 4",
        data: [700, 600, 500, 300],
        fill: true,
        tension: 0.2,
        backgroundColor: "rgba(255,206,86,0.2)", // Yellow
        borderColor: "rgba(255,206,86,1)",
      },
    ],
  };

  const [popupAnalics, setPopupAnalics] = useState({ type: "", data: "" });
  // const [popupAnalicsGraphType, setPopupAnalicsGraphType] = useState("");
  return (
    <Layout>
      {popUpType && (
        <Card.AddPopUp removePopUp={() => setPopUpType("")}>
          {/* Filters */}
          <BackHeader
            title={popUpType.replace(/_/g, " ")}
            rightSide={
              <button
                onClick={() => setIsOpenFiler(!isOpenFiler)}
                className={`border border-zinc-700 rounded-md px-5 py-1`}
              >
                {isOpenFiler ? "X" : "Filter"}
              </button>
            }
          />

          {isOpenFiler && (
            <div className=" bg-zinc-50 rounded-md p-2 mt-4">
              <p className="block text-sm font-medium text-gray-700">
                Filterd by
              </p>
              <div className="flex justify-between md:flex-nowrap flex-wrap  gap-3">
                <select
                  id="country"
                  name="country"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select Country</option>
                  {/* Options will be dynamically generated */}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "state" && ( */}
                <select
                  id="state"
                  name="state"
                  onChange={(e) => setStateFilter(e.target.value)}
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select State</option>
                  {Object.entries(stateData).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "city" && ( */}
                <select
                  id="city"
                  name="city"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select City</option>
                  {/* Options will be dynamically generated */}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "date" && ( */}
                <input
                  type="date"
                  id="date"
                  name="date"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                />
                {/* )} */}
              </div>
            </div>
          )}

          <div class="relative overflow-x-auto sm:rounded-lg mt-5">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Store Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Store Code
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Count
                  </th>
                </tr>
              </thead>
              <tbody>
                {filterdStores &&
                  filterdStores.map((store, index) => (
                    <tr
                      key={index}
                      className="bg-white border-b hover:bg-gray-50 "
                    >
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        {store?.storeName || "N/A"}
                      </th>
                      <td className="px-6 py-4">{store?.storeCode || "N/A"}</td>
                      <td className="px-6 py-4">{store.count}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Card.AddPopUp>
      )}
      {confirmationPopup && (
        <Card.Confirmation
          onClose={() => setConfirmationPopup(false)}
          onConfirm={() => navigate("/analytics/overview")}
          message="Are you sure "
        />
      )}
      {showFilterPopUp && (
        <Card.AddPopUp
          ClassName="h-auto "
          removePopUp={() => setConfirmationPopup(true)}
          // closeButton="false"
        >
          <div className="capitalize flex flex-col gap-2 h-fit max-h-[90vh] overflow-scroll">
            <div className="flex items-center justify-between pb-2 ">
              <div className="text-lg font-semibold text-center flex-grow">
                Filter by time and date
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-3 mt-3 bg-slate-50 p-4 rounded-md">
              <label
                key="catalog_generated"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_generated"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_generated"
                  }
                  onChange={handleInputChange}
                />
                Catalog Generated
              </label>

              <label
                key="catalog_sent"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent"
                  className="form-radio text-blue-600"
                  checked={advanceFilterData?.catalogStatus === "catalog_sent"}
                  onChange={handleInputChange}
                />
                Catalog Sent
              </label>

              <label
                key="catalog_sent_email"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent_email"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_sent_email"
                  }
                  onChange={handleInputChange}
                />
                Catalog Sent Email
              </label>

              <label
                key="catalog_sent_whatsapp"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent_whatsapp"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_sent_whatsapp"
                  }
                  onChange={handleInputChange}
                />
                Catalog Sent WhatsApp
              </label>

              <label
                key="catalog_downloaded"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_downloaded"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_downloaded"
                  }
                  onChange={handleInputChange}
                />
                Catalog Downloaded
              </label>

              <label
                key="order_placed"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="order_placed"
                  className="form-radio text-blue-600"
                  checked={advanceFilterData?.catalogStatus === "order_placed"}
                  onChange={handleInputChange}
                />
                Order Placed
              </label>
            </div>

            <div className="w-full bg-slate-50 p-4 rounded-md">
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Time
                </label>
                <Select
                  value={advanceFilterData?.timeType}
                  // onChange={(e) => setTimeType(e.target.value)}
                  name="timeType"
                  onChange={handleInputChange}
                  className="block w-full bg-white  text-gray-700 rounded-md py-2 px-3 sm:text-sm"
                  ContainerSubclassName="px-0 py-0"
                >
                  <option value="" disabled>
                    Select Duration
                  </option>
                  <option value="date">Date</option>
                  <option value="range">Range</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="quarter">Quarter</option>
                  <option value="year">Year</option>
                </Select>
              </div>
            </div>

            {advanceFilterData?.timeType && (
              <div className="p-3 bg-slate-50 rounded-lg  ">
                <Input.Normal
                  label={advanceFilterData?.timeType}
                  isInput={false}
                />
                {advanceFilterData?.timeType === "date" && (
                  <div className="flex gap-2">
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="Date"
                      name="date" // Bind to startDate in the state
                      value={advanceFilterData.startDate}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
                {advanceFilterData?.timeType === "range" && (
                  <div className="flex gap-2">
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="Start Date"
                      name="startDate" // Bind to startDate in the state
                      value={advanceFilterData.startDate}
                      onChange={handleInputChange}
                    />
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="End Date"
                      name="endDate" // Bind to endDate in the state
                      value={advanceFilterData.endDate}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
                {advanceFilterData?.timeType === "week" && (
                  <input
                    type="week"
                    className="border p-2 rounded-lg w-full"
                    placeholder="Select Week"
                    name="week" // Bind to week in the state
                    value={advanceFilterData.week}
                    onChange={handleInputChange}
                  />
                )}
                {advanceFilterData?.timeType === "month" && (
                  <input
                    type="month"
                    className="border p-2 rounded-lg w-full"
                    placeholder="Select Month"
                    name="month" // Bind to month in the state
                    value={advanceFilterData.month}
                    onChange={handleInputChange}
                  />
                )}
                {advanceFilterData?.timeType === "quarter" && (
                  <select
                    className="border p-2 rounded-lg w-full"
                    name="quarter" // Bind to quarter in the state
                    value={advanceFilterData.quarter}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Quarter</option>
                    <option value="Q1">Jan-Mar</option>
                    <option value="Q2">Apr-Jun</option>
                    <option value="Q3">Jul-Sep</option>
                    <option value="Q4">Oct-Dec</option>
                  </select>
                )}
                {advanceFilterData?.timeType === "year" && (
                  <select
                    className="border p-2 rounded-lg w-full"
                    name="year" // Bind to year in the state
                    value={advanceFilterData.year}
                    onChange={handleInputChange}
                  >
                    {Array.from({ length: 10 }, (_, index) => {
                      const year = new Date().getFullYear() - index;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-slate-50 p-6 rounded-lg">
              <select
                value={advanceFilterData?.selectedCountry}
                // onChange={handleCountryChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                name="selectedCountry"
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </select>

              <select
                value={advanceFilterData?.selectedState}
                // onChange={handleStateChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                disabled={!advanceFilterData?.selectedCountry}
                name="selectedState"
              >
                <option value="">Select State</option>
                {states[advanceFilterData?.selectedCountry]?.map((state) => (
                  <option key={state.code} value={state.code}>
                    {state.name}
                  </option>
                ))}
              </select>

              <select
                value={advanceFilterData?.selectedCity}
                // onChange={handleCityChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                disabled={!advanceFilterData?.selectedState}
                name="selectedCity"
              >
                <option value="">Select City</option>
                {cities[advanceFilterData?.selectedState]?.map((city) => (
                  <option key={city.code} value={city.code}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-center mt-5 ">
              <BlackButton handleSubmit={advanceFilterHandler} title="Apply" />
            </div>
          </div>
        </Card.AddPopUp>
      )}

      {popupAnalics?.type && (
        <Card.AddPopUp
          className=""
          height="90%"
          width="w-[95%]"
          removePopUp={() => setPopupAnalics("")}
          closeButtonClassName="border-none"
        >
          <div className="flex w-full h-full overflow-hidden gap-3">
            {/* Left Side */}
            <div className="w-[70%] flex flex-col justify-between rounded-lg">
              <div className="w-full">
                <p className="text-4xl font-semibold">Heading</p>
                <p className="text-sm text-zinc-600">sub heading</p>
              </div>
              <popupAnalics.type
                data={dummyGraph}
                style={{ height: "", width: "100%" }}
              />
              <div className="bg-sky-50 border border-sky-300 p-1 px-10 rounded-lg">
                One line details
              </div>
            </div>
            {/* Right Side */}
            <div className="w-[30%] overflow-auto h-full border rounded-lg p-4 bg-gray-50 space-y-4">
              {/* Dropdown */}
              <div className="flex justify-end">
                <select
                  id="country"
                  name="country"
                  className="border m-1 block pl-3 pr-4 py-1 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select Country</option>
                  <option value="US">United States</option>
                  <option value="UK">United Kingdom</option>
                  <option value="IN">India</option>
                  <option value="AU">Australia</option>
                </select>
              </div>
              {/* Statistics Section */}
              <div className="space-y-4">
                {/* Statistics Card 1 */}
                <div className="flex items-center bg-blue-100 p-4 rounded-lg shadow">
                  <div className="bg-blue-500 text-white p-3 rounded-full">
                    📈
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-gray-600">Total Views</p>
                    <p className="text-lg font-semibold text-blue-800">
                      12,345
                    </p>
                  </div>
                </div>
                {/* Statistics Card 2 */}
                <div className="flex items-center bg-green-100 p-4 rounded-lg shadow">
                  <div className="bg-green-500 text-white p-3 rounded-full">
                    🛒
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-gray-600">Total Sales</p>
                    <p className="text-lg font-semibold text-green-800">
                      $56,789
                    </p>
                  </div>
                </div>
                {/* Statistics Card 3 */}
                <div className="flex items-center bg-yellow-100 p-4 rounded-lg shadow">
                  <div className="bg-yellow-500 text-white p-3 rounded-full">
                    🧑‍🤝‍🧑
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-gray-600">New Users</p>
                    <p className="text-lg font-semibold text-yellow-800">
                      1,234
                    </p>
                  </div>
                </div>
                {/* Statistics Card 4 */}
                <div className="flex items-center bg-red-100 p-4 rounded-lg shadow">
                  <div className="bg-red-500 text-white p-3 rounded-full">
                    💬
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-gray-600">Feedback</p>
                    <p className="text-lg font-semibold text-red-800">320</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.AddPopUp>
      )}

      <Container>
        <div className=" w-full h-full overflow-scroll rounded-xl  py-4 px-2">
          {/* <div className="flex flex-col-reverse md:flex-row gap-5 items-middle items-end w-full mb-5">
            <div className="flex justify-between items-end w-full">
              <div>
                <label className="block text-xs md:text-base text-gray-700 mb-1">
                  Select Date Range:
                </label>

                <select
                  className="px-4 py-2 text-xs md:text-base rounded-md bg-white border"
                  value={selectedRange}
                  onChange={handleRangeChange}
                >
                  <option value="today">Today</option>
                  <option value="last7days">Last 7 Days</option>
                  <option value="last15days">Last 15 Days</option>
                  <option value="lastMonth">last Month</option>
                  <option value="customDate">Date Range</option>
                </select>
              </div>

              <BlackButton
                title="Filter"
                handleSubmit={() => setShowFilterPopUp(true)}
              />
            </div>
            <div>
              {selectedRange === "customDate" && (
                <div className="flex flex-row items-center gap-4">
                  <div>
                    <label className="block text-xs md:text-base text-gray-700 mb-1">
                      Start Date:
                    </label>
                    <input
                      type="date"
                      className="px-1 py-1 text-sm md:text-base md:px-4 md:py-2 border rounded-md"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="block text-sm md:text-base text-gray-700 mb-1">
                      End Date:
                    </label>
                    <input
                      type="date"
                      className="px-1 py-1 text-xs md:text-base md:px-4 md:py-2 border rounded-md"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>

            {selectedRange === "customDate" && (
              <button
                onClick={FilterHandler}
                className="bg-black p-2 px-5 text-white rounded-md"
              >
                Apply
              </button>
            )}
          </div> */}
          <div className="flex items-center justify-between mb-6 gap-4">
            {Object.entries(analytics?.report || {}).map(
              ([key, value], index) => (
                <StatCard
                  key={key}
                  label={key.replace(/_/g, " ")}
                  value={value}
                  onClick={() => setPopUpType(key)}
                  // backgroundColor={ColorCardCode[index]}
                />
              ),
            )}
          </div>
          <div className=" w-full gap-1 lg:gap-2 grid grid-cols-6 ">
            <div
              className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg  cursor-pointer p-4 col-span-2 ${
                permissions?.analytics === true && ""
              } w-full  bg-white/100  p-3`}
              onClick={() => setPopupAnalics({ type: Line, data: "" })}
            >
              <Line data={dummyGraph} style={{ height: "", width: "" }} />
            </div>
            <div
              className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg  cursor-pointer p-4  col-span-2 ${
                permissions?.analytics === true && ""
              } w-full  bg-white/100  p-3`}
              onClick={() => setPopupAnalics({ type: Bar, data: "" })}
            >
              <Bar data={dummyGraph} style={{ height: "", width: "" }} />
            </div>

            <div
              className="shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg  cursor-pointer p-4   col-span-2"
              onClick={() => setPopupAnalics({ type: Scatter, data: "" })}
            >
              <Scatter data={dummyGraph} />
            </div>

            {/* <div className="shadow-sm my-2 rounded-lg  h-[30rem] w-full  bg-white/100 lg:hidden block overflow-hidden">
                
                <div className="flex items-center py-1 px-2  rounded-xl  w-full bg-white/100 border ">
                  <FiSearch />
                  <input
                    type="text"
                    placeholder="search here..."
                    className="outline-none w-full px-2  "
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
                
                <div className=" overflow-y-scroll h-4/5  flex flex-col p-2 gap-2 w-full">
                  {filteredStores.length > 0 && searchInput
                    ? filteredStores.map((item, index) => (
                        <div className=" bg-zinc-50 shadow-sm rounded-lg p-2 border w-full">
                          <div className="flex gap-2 text-sm">
                            <p className="font-medium ">Store Name:</p>
                            <p>{item.storename}</p>
                          </div>
                          <div className="flex gap-2 text-sm">
                            <p className="font-medium ">Store Code:</p>
                            <p>{item.storecode}</p>
                          </div>
                          <div className="flex gap-2 text-sm">
                            <p className="font-medium ">Address:</p>
                            <p>{item.Address}</p>
                          </div>
                        </div>
                      ))
                    : storeData &&
                      storeData.map(
                        (item, index) =>
                          index < 5 && (
                            <div className=" bg-zinc-50 shadow-sm rounded-lg p-2 border">
                              <div className="flex gap-2 text-sm">
                                <p className="font-medium ">Store Name:</p>
                                <p>{item.storename}</p>
                              </div>
                              <div className="flex gap-2 text-sm">
                                <p className="font-medium ">Store Code:</p>
                                <p>{item.storecode}</p>
                              </div>
                            </div>
                          )
                      )}
                </div>
                {storeData && (
                  <div className="flex justify-end">
                    <NavLink
                      to="/admin/viewstore"
                      className="bg-black text-white px-3 py-2 rounded-lg mt-3 lg:text-base text-xs m-2"
                    >
                      View store data
                    </NavLink>
                  </div>
                )}
              </div> */}
          </div>

          {/* <div className='flex w-full lg:flex-row flex-col gap-1 lg:gap-2 mt-5'>
            <SegmentedDonutChart
              title="Online Requests"
              totalRequests={9245}
              newRequests={5900}
              returningRequests={3100}
            />

            <SegmentedDonutChart
              title="In-Store Requests"
              totalRequests={4200}
              newRequests={2700}
              returningRequests={1500}
            />

            <SegmentedTrafficBar
              title={trafficData.title}
              subtitle={trafficData.subtitle}
              totalVisitors={trafficData.totalVisitors}
              segments={trafficData.segments}
            /> */}

          <div className="flex flex-col lg:flex-row w-full gap-4 mt-5">
            {/* Online Requests */}
            <div
              className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg lg:w-1/3 cursor-pointer p-4`}
            >
              <SegmentedDonutChart
                title="Online Requests"
                totalRequests={9245}
                newRequests={5900}
                returningRequests={3100}
              />
            </div>

            {/* In-Store Requests */}
            <div
              className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg lg:w-1/3 cursor-pointer p-4`}
            >
              <SegmentedDonutChart
                title="In-Store Requests"
                totalRequests={4200}
                newRequests={2700}
                returningRequests={1500}
              />
            </div>

            {/* Website Traffic */}
            <div
              className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg lg:w-1/3 cursor-pointer p-4`}
            >
              <SegmentedTrafficBar
                title={trafficData.title}
                subtitle={trafficData.subtitle}
                totalVisitors={trafficData.totalVisitors}
                segments={trafficData.segments}
              />
            </div>
            {/* </div> */}

            {/* <div className='shadow-sm rounded-lg py-4 w-[100%] h-[50%] md:w-[50%] md:h-[70%] bg-white flex justify-center items-center'>
              <Doughnut data={PieData} />
            </div>
            <div className='flex flex-row w-[100%] md:w-[50%] gap-4 justify-between'>
              <div
                className='flex bg-slate-200 w-[50%] p-3 hover:bg-slate-300 justify-evenly rounded-md items-center'
                onClick={openPopup}
              >
                <div className=''>
                  <img
                    className='w-6 h-6 md:w-9 md:h-9 object-cover'
                    src='/image/viewpdf.png'
                    alt=''
                  />
                </div>
                <div className='text-center'>
                  <h2 className='text-xs md:text-xl font-semibold'>
                    View PDF Generate
                  </h2>
                </div>
              </div>
              <div className='bg-slate-200 w-[50%] p-3 hover:bg-slate-300 rounded-md '>
                <Link
                  to='/admin/storedatewise'
                  className='flex justify-evenly items-center'
                >
                  <div className=''>
                    <img
                      className='w-6 h-6 md:w-9 md:h-9 object-cover'
                      src='/dashboardLogo/datepdf.png'
                      alt=''
                    />
                  </div>
                  <div className='text-center'>
                    <h2 className='text-xs md:text-xl font-semibold '>
                      Date Wise PDF Generate
                    </h2>
                  </div>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default AnalyticsReport;

const StatCard = ({ label, value, key, onClick, backgroundColor }) => (
  <div
    className="cursor-pointer hover:bg-zinc-100 text-center w-full shadow rounded-md py-3"
    key={key}
    onClick={onClick}
    style={{ backgroundColor: backgroundColor ? backgroundColor : "#fff" }}
  >
    <p className="text-xs md:text-sm font-semibold text-gray-500">{label}</p>
    <p className="text-base md:text-lg font-semibold text-gray-800">{value}</p>
  </div>
);
